import React, { useState } from 'react'

export function useForm2(getFreshModelObject2) {

    const [values, setValues] = useState(getFreshModelObject2());
    const [errors, setErrors] = useState({});

    const handleInputChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
    }

    const resetFormControls = () => {
        setValues(getFreshModelObject2());
        setErrors({})
    }

    return {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetFormControls
    }
}

